import InstabilityMessagesConfig from './InstabilityMessagesConfig';
import { InstabilityMessageModel } from '../interfaces/InstabilityMessageModel';

export function filterInstabilityMessages(messages: InstabilityMessageModel[]): string[] {
  if (!messages) return [];
  const config = InstabilityMessagesConfig.Current();
  return messages
    .filter((obj) => (obj.authenticated === obj.notAuthenticated) || (config.keepAuthenticated && obj.authenticated) || (config.keepNotAuthenticated && obj.notAuthenticated))
    .map((obj) => obj.message);
}
